import React, { useState } from 'react'
import { supabase } from '../supabaseClient'

export default function Login() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  async function handleLogin() {
    if (!email || !password) { setError('Please fill in all fields.'); return }
    setLoading(true)
    setError(null)
    const { error: signInError } = await supabase.auth.signInWithPassword({ email, password })
    if (signInError) { setError('Invalid email or password.'); setLoading(false); return }
    const params = new URLSearchParams(window.location.search)
    const redirect = params.get('redirect') || '/'
    window.location.href = redirect
  }

  return (
    <div>
      <nav className="topnav">
        <a href="/" className="topnav-logo">PREDICTA</a>
        <a href="/register" className="btn btn-primary" style={{ padding: '7px 16px', fontSize: '13px' }}>Register</a>
      </nav>

      <div className="container-narrow">
        <div style={{ textAlign: 'center', paddingTop: '48px', marginBottom: '32px' }}>
          <h1 style={{ fontFamily: 'var(--ff-d)', fontWeight: '700', fontSize: '36px', marginBottom: '8px' }}>Welcome back</h1>
          <p style={{ color: 'var(--text-2)' }}>Log in to your Predicta account</p>
        </div>

        <div className="card">
          {error && (
            <div style={{ background: 'rgba(220,38,38,0.08)', border: '1px solid rgba(220,38,38,0.2)', borderRadius: 'var(--r)', padding: '10px 14px', marginBottom: '16px' }}>
              <p style={{ color: 'var(--red)', fontSize: '13px' }}>{error}</p>
            </div>
          )}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            <div>
              <label style={{ display: 'block', fontSize: '11px', fontWeight: '600', letterSpacing: '.08em', textTransform: 'uppercase', color: 'var(--text-2)', marginBottom: '7px' }}>Email</label>
              <input type="email" placeholder="you@example.com" value={email} onChange={e => setEmail(e.target.value)} onKeyDown={e => e.key === 'Enter' && handleLogin()} />
            </div>
            <div>
              <label style={{ display: 'block', fontSize: '11px', fontWeight: '600', letterSpacing: '.08em', textTransform: 'uppercase', color: 'var(--text-2)', marginBottom: '7px' }}>Password</label>
              <input type="password" placeholder="••••••••" value={password} onChange={e => setPassword(e.target.value)} onKeyDown={e => e.key === 'Enter' && handleLogin()} />
            </div>
          </div>
          <button className="btn btn-primary" onClick={handleLogin} disabled={loading} style={{ width: '100%', marginTop: '20px', padding: '13px', fontSize: '15px' }}>
            {loading ? 'Logging in...' : 'Log in'}
          </button>
          <div style={{ textAlign: 'center', marginTop: '16px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
            <p style={{ fontSize: '13px', color: 'var(--text-2)' }}>
              No account? <a href="/register" style={{ color: 'var(--gold)', fontWeight: '600' }}>Register here</a>
            </p>
            <a href="/forgot-password" style={{ fontSize: '12px', color: 'var(--text-3)' }}>Forgot your password?</a>
          </div>
        </div>
      </div>
    </div>
  )
}